module.exports = __webpack_public_path__ + "static/img/一带一路数字展厅 (1).88873605.png";